import i18n from 'i18next';

import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';
import { GraphQLErrors } from '@apollo/client/errors';

export const gqlErrorHandler = (graphQLErrors: GraphQLErrors) => {
  const extensions = graphQLErrors[0].extensions as any;

  if (extensions && extensions.code === 'BAD_USER_INPUT') {
    const errorMessage = graphQLErrors[0]?.message
    return showNotification({
      type: NOTIFICATION_TYPE.error,
      message: extensions?.response?.error || i18n.t('common:notifications.error.title'),
      description:
        extensions?.response?.message ||
        errorMessage ||
        i18n.t(extensions?.exception?.i18nTranslationPath || 'common:notifications.error.subTitle'),
    });
  }

  if (
    (extensions && extensions.code === 'UNAUTHENTICATED') ||
    graphQLErrors[0].message === 'Unauthorized'
  ) {
    return;
  }

  return showNotification({
    type: NOTIFICATION_TYPE.error,
    message: i18n.t('common:notifications.error.title'),
    description: i18n.t(
      extensions?.exception?.i18nTranslationPath || 'common:notifications.error.subTitle'
    ),
  });
};
